import { useState, useEffect } from 'react';

export function useLaunchStatus(launchDateString) {
  const [isLaunched, setIsLaunched] = useState(false);
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const launchTime = new Date(launchDateString).getTime();

    const calculateTime = () => {
      const now = new Date().getTime();
      const difference = launchTime - now;

      if (difference <= 0) {
        setIsLaunched(true);
        return;
      }

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      });
    };

    calculateTime();
    const timer = setInterval(calculateTime, 1000);

    return () => clearInterval(timer);
  }, [launchDateString]);

  return { isLaunched, timeLeft };
}
